import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const NewZealandFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15666'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15666)'>
				<rect
					width='20'
					height='14'
					fill='#0A17A7'
				/>
				<path
					d='M-0.915074 -0.333333H0H0.47619H0.581265L0.667345 -0.273077L3.9146 2H4.66793L8.39732 -0.284251L8.90476 -0.595057V0V0.293115C8.90476 0.510658 8.79862 0.714517 8.6204 0.839269L5.57143 2.97355V3.578L8.45876 6.00336C8.80818 6.29688 8.60063 6.86667 8.14428 6.86667C8.04397 6.86667 7.94608 6.83581 7.8639 6.77828M-0.915074 -0.333333L7.8639 6.77828M-0.915074 -0.333333L-0.214397 0.255235L3 2.95533V3.55978L-0.191154 5.79359L-0.333333 5.89311V6.06667V6.53333V7.12839L0.174104 6.81758L3.90349 4.53333H4.65683L7.8639 6.77828M-0.915074 -0.333333L7.8639 6.77828'
					fill='#FF2E3B'
					stroke='white'
					strokeWidth='0.666667'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 2.33333V4.2H3.33333V6.33333C3.33333 6.70152 3.63181 7 4 7H4.57143C4.93962 7 5.23809 6.70152 5.23809 6.33333V4.2H8.38095C8.74914 4.2 9.04762 3.90152 9.04762 3.53333V3C9.04762 2.63181 8.74914 2.33333 8.38095 2.33333H5.23809V0H3.33333V2.33333H0Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 2.8H3.80952V2.33333V0H4.7619V2.33333V2.8H8.57143V3.73333H4.7619V4.2V6.53333H3.80952V4.2V3.73333H0V2.8Z'
					fill='#FF2E3B'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M14.2864 12.1333L13.6129 12.3266L13.8102 11.6666L13.6129 11.0066L14.2864 11.1999L14.9598 11.0066L14.7626 11.6666L14.9598 12.3266L14.2864 12.1333Z'
					fill='#CA1931'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M14.2864 3.2667L13.6129 3.46L13.8102 2.80003L13.6129 2.14007L14.2864 2.33337L14.9598 2.14007L14.7626 2.80003L14.9598 3.46L14.2864 3.2667Z'
					fill='#CA1931'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M17.1438 6.06663L16.4704 6.25993L16.6676 5.59996L16.4704 4.93999L17.1438 5.13329L17.8172 4.93999L17.62 5.59996L17.8172 6.25993L17.1438 6.06663Z'
					fill='#CA1931'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M11.4289 6.99998L10.7555 7.19328L10.9528 6.53331L10.7555 5.87334L11.4289 6.06664L12.1024 5.87334L11.9051 6.53331L12.1024 7.19328L11.4289 6.99998Z'
					fill='#CA1931'
				/>
			</g>
		</svg>
	);
};

export default NewZealandFlagIcon;
